import { useUserState } from '@/stores/useUserState';
import { app } from '@ibgroup-tws-webapps/ratio.ui';

let _orderTicketPending = false;
let _pendingTimer: ReturnType<typeof setTimeout> | undefined;

export function isOrderTicketPending(): boolean {
  return _orderTicketPending;
}

export type TradeContractExtras = {
  action?: 'B' | 'S';
  size?: number;
  close?: boolean;
  source?: string;
  account?: string;
  secType?: string;
};

export function useOrderTicket() {
  const userState = useUserState();

  function openOrderTicket(
    conid: number,
    intent?: string,
    exchange?: string,
    eventConidExs?: string[],
    extras?: TradeContractExtras,
  ) {
    try {
      console.log('openOrderTicket', { conid, intent, exchange, eventConidExs, extras });
      window.$apm?.logUserInteractionEvent('useOrderTicket', 'open-order-ticket', {
        conid,
        intent,
        exchange,
        eventConidExs,
        extras,
      });

      const acctId = userState.account;
      const message = {
        action: 'trade_contract',
        data: {
          conidEx: '' + conid,
          action: extras?.action ?? (intent === 'close' && exchange !== 'FORECASTX' ? 'S' : 'B'),
          ...(intent === 'close' && { close: true }),
          ...(exchange && { exchange }),
          ...(app.option.supportsMultiVenue && eventConidExs?.length && { eventConidExs }),
          ...(extras?.size !== undefined && { size: extras.size }),
          ...(extras?.close !== undefined && { close: extras.close }),
          ...(extras?.source && { source: extras.source }),
          ...(extras?.account && { account: extras.account }),
          ...(extras?.secType && { secType: extras.secType }),
          ...((app.option.clientPlatform === 'web' || app.option.platform === 'web') && { acctId }),
        },
      };

      app.send(message);
      return;
    } catch (e) {
      _orderTicketPending = false;
      clearTimeout(_pendingTimer);
      console.error('Failed to open order ticket:', e);
    }
  }

  return { openOrderTicket };
}
